import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetStaticProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Fragment } from 'react';

import { EventListContent } from '@/components/ui/features/events-list/EventListContent/EventListContent';
import { featuredThinEventQueryOptions } from '@/queries/upgrade/thinEvents';

const EventListPage: NextPage = () => {
  return (
    <Fragment>
      <NextSeo
        title="Explore scientific conferences"
        description="Find video lectures from your field's conferences worldwide. Underline's collection of conferences is always growing."
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/coreEvents`,
          title: 'Explore scientific conferences',
          description:
            "Find video lectures from your field's conferences worldwide. Underline's collection of conferences is always growing.",
        }}
      />
      <EventListContent />
    </Fragment>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const queryClient = new QueryClient();

  try {
    await queryClient.prefetchQuery(featuredThinEventQueryOptions());
  } catch (err) {
    return { notFound: true };
  }

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 120,
  };
};

export default EventListPage;
